var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="ko-component-file-upload2-wrap"data-bind="ko-component-file-upload2#jqFileupload: {\n		multiple: _params.multiple\n	}"></div>';
}
return __p;
};
